import {
  selectEntries,
  setHoverDeleteButton,
} from '@databases/redux/cellSelections/actions';
import { appStore } from '@databases/redux/store';

/**
 * Handles the mouse enter event for the delete entry button in the contextual menu.
 */
export function onMouseEnterDeleteEntryButton(
  selectedEntryIds: string[],
  contentId: string
): void {
  appStore.dispatch(setHoverDeleteButton({ value: 'entries' }));
  appStore.dispatch(
    selectEntries({
      contentId,
      entryIds: selectedEntryIds,
      clearSelectedValues: false,
    })
  );
}
